// extracted by mini-css-extract-plugin
export var cardImage = "style-module--cardImage--sZ0As";
export var root = "style-module--root--3sITX";
export var subHeading = "style-module--subHeading--ANqID";
export var textWrapper = "style-module--textWrapper--dxu+e";